import React from 'react';

interface FallbackProps {
  error: Error;
  onReset: () => void;
}

export const SectionErrorFallback: React.FC<FallbackProps> = ({ error, onReset }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '120px 16px' }}>
    <div style={{ border: '1px solid #dee2e6', borderRadius: 12, padding: 32, maxWidth: 400, width: '100%', textAlign: 'center', background: '#fff' }}>
      <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 4 }}>Something went wrong</div>
      <div style={{ fontSize: 14, color: '#868e96', marginBottom: 12 }}>
        This section couldn't load. You can try again or go back.
      </div>
      {error.message && (
        <div style={{ fontSize: 13, color: '#e03131', marginBottom: 16, wordBreak: 'break-word' }}>
          {error.message}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        <button
          onClick={() => window.location.href = '/accounts'}
          style={{ padding: '6px 16px', borderRadius: 20, border: '1px solid #dee2e6', background: '#f8f9fa', color: '#495057', cursor: 'pointer', fontSize: 13 }}
        >
          Back to sections
        </button>
        <button
          onClick={onReset}
          style={{ padding: '6px 16px', borderRadius: 20, border: 'none', background: '#e7f5ff', color: '#1c7ed6', cursor: 'pointer', fontSize: 13 }}
        >
          Try again
        </button>
      </div>
    </div>
  </div>
);

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

class SectionErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  private handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return <SectionErrorFallback error={this.state.error} onReset={this.handleReset} />;
    }

    return this.props.children;
  }
}

export default SectionErrorBoundary;
